import Backdrop from "../Bootstrap/util/backdrop";

let backdrop = null;

export function initialize() {
    document.querySelector('#navbarSideCollapse').addEventListener('click', function () {
        let toggleButton = this;
        let area = document.querySelector('.offcanvas-collapse');
        area.classList.toggle('open');

        if(backdrop === null) {
            backdrop = new Backdrop({
              isVisible: true,
              isAnimated: true,
              rootElement: area.parentNode,
              clickCallback: function() {
                 toggleButton.click();
                 backdrop.dispose();
                 backdrop = null;
              }
            });

            backdrop.show();
        }
    });
}
